import { Link } from 'react-router'
import { Card, CardDescription, CardHeader, CardTitle } from '@klear/ui/components/card'
import { Button } from '@klear/ui/components/button'
import { useAuth } from '@klear/ui/contexts/auth-context'
import { ArrowRight } from 'lucide-react'
import {
  ROUTE_REPORTS,
  ROUTE_REPORTS_PAYMENTS,
  ROUTE_REPORTS_FUNDING,
  PERMISSION_ENTITY_INVOICE_OFFER,
  PERMISSION_ACTION_VIEW
} from '@klear/constants'
import { useDocumentTitle } from '@klear/ui/hooks/use-document-title'

export default function Reports() {
  useDocumentTitle('Reports')
  const { user } = useAuth()
  const canViewFundingReport = user?.hasPermission(PERMISSION_ENTITY_INVOICE_OFFER, PERMISSION_ACTION_VIEW) ?? false

  return (
    <div className="p-6 space-y-6">
      <h1 className="text-2xl font-semibold">Reports</h1>

      <Card>
        <CardHeader className="flex flex-row items-start justify-between gap-4">
          <div>
            <CardTitle>Payments report</CardTitle>
            <CardDescription>
              View payment records in-app or export them to CSV. Opens a full-screen table view.
            </CardDescription>
          </div>
          <Button asChild className="shrink-0">
            <Link to={`/${ROUTE_REPORTS}/${ROUTE_REPORTS_PAYMENTS}`}>
              Open
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </CardHeader>
      </Card>

      {canViewFundingReport && (
        <Card>
          <CardHeader className="flex flex-row items-start justify-between gap-4">
            <div>
              <CardTitle>Funding report</CardTitle>
              <CardDescription>
                View funded invoice offers by period or outstanding exposure by SPV. Opens a full-screen table view with
                summary cards.
              </CardDescription>
            </div>
            <Button asChild className="shrink-0">
              <Link to={`/${ROUTE_REPORTS}/${ROUTE_REPORTS_FUNDING}`}>
                Open
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </CardHeader>
        </Card>
      )}
    </div>
  )
}
